import MlmPhotosTwilight from './MlmPhotosTwilight';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { MlmOrderContext } from '../../model/MlmOrder';
import MlmPhotosCommunity from './MlmPhotosCommunity';
import MlmPhotosDetail from '~/tenants/mlm/performable/photos/MlmPhotosDetail';

export default function MlmPhotosAddOns(props: Pick<TenantPerformableFormProps<MlmOrderContext>, 'persona'>) {
  return (
    <>
      <MlmPhotosTwilight {...props} />
      <MlmPhotosCommunity {...props} />
      <MlmPhotosDetail {...props} />
    </>
  );
}
